import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import PentagonChart from './Components/PentagonChart';
import Navbar from './Components/Navbar';
import MainLayout from './Components/MainLayout';

function App() {
  return (
    <Router>
      <Helmet>
        <title>Custom Radar Chart Maker — Free Spider Chart Generator Online</title>
        <meta name="description" content="Create beautiful custom radar charts and spider charts online for free. No signup required. Perfect for data analysis, sports stats, competitive comparison, and presentations." />
        <meta property="og:title" content="Custom Radar Chart Maker — Free & Online" />
        <meta property="og:description" content="Create stunning radar and spider charts in seconds. Free, no sign-up, fully customizable." />
        <meta property="og:url" content="https://customradarchart.com/" />
        <meta name="twitter:title" content="Custom Radar Chart Maker — Free & Online" />
        <meta name="twitter:description" content="Create stunning radar and spider charts in seconds. Free, no sign-up, fully customizable." />
      </Helmet>
      <div className="App">
        <Navbar />
        
        {/* MainLayout con sidebars de ads */}
        <MainLayout>
          <PentagonChart />
        </MainLayout>
      </div>
    </Router>
  );
}

export default App;